import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { saveReferenceForLater } from '../../../core/api';
import RefereePageLayout from '../../layouts/RefereePageLayout';
import SecondaryButton from '../../common/buttons/SecondaryButton';
import { hasValue } from '../../../lib/utils';
import './RefereeSaved.less';
import Buttons from '../../common/Buttons';

const RefereeSaved = () => {
	const handleResume = () => {
		window.history.back();
	};

	return (
		<RefereePageLayout className="refereeSavedPage" title="Saved">
			<h1>Saved!</h1>
			<p>
				We&#39;ve sent you a new secure link on your email that you can use, at your convenience, to continue from where
				you left off.
			</p>
			<Buttons>
				<SecondaryButton text="Resume" onClick={handleResume} />
			</Buttons>
		</RefereePageLayout>
	);
};

export default RefereeSaved;

export const SaveAndFinishLater = ({ refereeToken, currentPagePath, onSave }: SaveAndFinishLaterProps) => {
	const navigate = useNavigate();

	const handleClick = async () => {
		if (hasValue(onSave)) {
			await onSave();
		}
		await saveReferenceForLater(refereeToken, currentPagePath);
		navigate('/referee/saved');
	};

	return (
		<a className="saveAndFinishLaterButton anchorButton" onClick={handleClick}>
			Save and finish later
		</a>
	);
};

SaveAndFinishLater.defaultProps = {
	onSave: null
} as Partial<SaveAndFinishLaterProps>;

interface SaveAndFinishLaterProps {
	refereeToken: string;
	currentPagePath: string;
	onSave?: () => Promise<void>;
}
